import { EditorModule } from 'primeng/editor';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TooltipModule } from 'primeng/tooltip';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { MultiSelectModule } from 'primeng/multiselect';
// The History tab's filter bar, matching the admin screens': icon-prefixed search with its own
// clear button, and ngModel-bound dropdowns and date pickers.
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { RippleModule } from 'primeng/ripple';
import { FormsModule } from '@angular/forms';
import { EditPanelContainerComponent } from './components/edit-panel-container/edit-panel-container.component';
import { TestSummaryTableComponent } from './components/workspace/test-summary-table/test-summary-table.component';
import { StripHtmlPipe } from '../catch-core/pipes/pipes/strip-html.pipe';
import { WorkspaceNodeAttachmentComponent } from './components/workspace/attachment/workspace-node-attachment/workspace-node-attachment.component';
import { CatchCoreModule } from '../catch-core/catch-core.module';
import { NgModule } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ColorPickerModule } from 'ngx-color-picker';

import { TabsModule } from 'primeng/tabs';

import { SharedEditPanelRoutingModule } from './shared-edit-panel.routing.module';
import { FilterStatusColorPipe } from '../catch-core/pipes/pipes/filter-status-color.pipe';

import { CommentComponent } from './components/comment/comment.component';

import { WorkspaceEdgePropertyComponent } from './components/workspace/workspace-edge-property/workspace-edge-property.component';
import { WorkspaceRootPropertyComponent } from './components/workspace/workspace-root-property/workspace-root-property.component';
import { WorkspaceRootAttachmentComponent } from './components/workspace/attachment/workspace-root-attachment/workspace-root-attachment.component';
import { WorkspaceTableAttachmentsComponent } from './components/workspace/attachment/workspace-table-attachment/workspace-table-attachment.component';
import { WorkspaceProjectAttachmentComponent } from './components/workspace/attachment/workspace-project-attachment/workspace-project-attachment.component';

import { BlueprintFieldCheckboxComponent } from './components/blueprint/blueprint-field-property/blueprint-field-checkbox/blueprint-field-checkbox.component';
import { BlueprintFieldDateComponent } from './components/blueprint/blueprint-field-property/blueprint-field-date/blueprint-field-date.component';
import { BlueprintFieldDatetimeComponent } from './components/blueprint/blueprint-field-property/blueprint-field-datetime/blueprint-field-datetime.component';
import { BlueprintFieldDropdownSingleComponent } from './components/blueprint/blueprint-field-property/blueprint-field-dropdown-single/blueprint-field-dropdown-single.component';
import { BlueprintFieldDropdownMultipleComponent } from './components/blueprint/blueprint-field-property/blueprint-field-dropdown-multiple/blueprint-field-dropdown-multiple.component';
import { BlueprintFieldMemoComponent } from './components/blueprint/blueprint-field-property/blueprint-field-memo/blueprint-field-memo.component';
import { BlueprintFieldNumberComponent } from './components/blueprint/blueprint-field-property/blueprint-field-number/blueprint-field-number.component';
import { BlueprintFieldRadioGroupComponent } from './components/blueprint/blueprint-field-property/blueprint-field-radio-group/blueprint-field-radio-group.component';
import { BlueprintFieldTableComponent } from './components/blueprint/blueprint-field-property/blueprint-field-table/blueprint-field-table.component';
import { BlueprintFieldUserComponent } from './components/blueprint/blueprint-field-property/blueprint-field-user/blueprint-field-user.component';
import { BlueprintFieldUrlComponent } from './components/blueprint/blueprint-field-property/blueprint-field-url/blueprint-field-url.component';
import { BlueprintFieldFormattedTextComponent } from './components/blueprint/blueprint-field-property/blueprint-field-formatted-text/blueprint-field-formatted-text.component';
import { BlueprintFieldTextComponent } from './components/blueprint/blueprint-field-property/blueprint-field-text/blueprint-field-text.component';
import { EditPanelDetailsPaneComponent } from './components/edit-panel-details-pane/edit-panel-details-pane.component';
import { DynamicFieldInputComponent } from './components/dynamic-field-input/dynamic-field-input.component';
import { EditPanelStepsPaneComponent } from './components/edit-panel-steps-pane/edit-panel-steps-pane.component';
import { EditPanelAttachmentsPaneComponent } from './components/edit-panel-attachments-pane/edit-panel-attachments-pane.component';
import { EditPanelCommentsPaneComponent } from './components/edit-panel-comments-pane/edit-panel-comments-pane.component';
import { EditPanelHeaderComponent } from './components/edit-panel-header/edit-panel-header.component';
import { EditPanelDescriptionComponent } from './components/edit-panel-description/edit-panel-description.component';

import { BlueprintEdgePropertyComponent } from './components/blueprint/blueprint-edge-property/blueprint-edge-property.component';
import { BlueprintRootPropertyComponent } from './components/blueprint/blueprint-root-property/blueprint-root-property.component';
import { BlueprintNodePropertyComponent } from './components/blueprint/blueprint-node-property/blueprint-node-property.component';

import { TableComponent } from './components/blueprint/blueprint-property-binding-table/table/table.component';

import { DataService } from './components/blueprint/blueprint-property-binding-table/services/data.service';

import { NodeFieldsTableComponent } from './components/blueprint/blueprint-field-add-to-node-table/table/table.component';
import { NodeFieldAddDialogComponent } from './components/blueprint/blueprint-field-add-to-node-table/dialog/add-dialog/add-dialog.component';
import { NodeFieldEditDialogComponent } from './components/blueprint/blueprint-field-add-to-node-table/dialog/edit-dialog/edit-dialog.component';
import { NodeFieldDeleteDialogComponent } from './components/blueprint/blueprint-field-add-to-node-table/dialog/delete-dialog/delete-dialog.component';
import { NodeFieldsDataService } from './components/blueprint/blueprint-field-add-to-node-table/services/data.service';

import { OrgAttachmentsComponent } from '../../components/organization/org-attachments/org-attachments.component';
import { TestStepTableModule } from './modules/test-step-table/test-step-table.module';
import { NodeSummaryTableModule } from '../../components/node-summary-table/node-summary-table.module';
import { EditPanelRunsPaneComponent } from './components/edit-panel-runs-pane/edit-panel-runs-pane.component';
import { EditPanelHistoryPaneComponent } from './components/edit-panel-history-pane/edit-panel-history-pane.component';
import { TestRunsStatusChartComponent } from './components/edit-panel-runs-pane/test-runs-status-chart/test-runs-status-chart.component';
import { RichTextFieldComponent } from './components/rich-text-field/rich-text-field.component';
import { ImageLightboxComponent } from './components/image-lightbox/image-lightbox.component';

@NgModule({
  declarations: [
    EditPanelContainerComponent,
    EditPanelHeaderComponent,
    EditPanelDetailsPaneComponent,
    DynamicFieldInputComponent,
    EditPanelStepsPaneComponent,
    EditPanelAttachmentsPaneComponent,
    EditPanelCommentsPaneComponent,
    EditPanelDescriptionComponent,
    EditPanelRunsPaneComponent,
    EditPanelHistoryPaneComponent,
    TestRunsStatusChartComponent,
    WorkspaceEdgePropertyComponent,
    WorkspaceRootPropertyComponent,
    WorkspaceNodeAttachmentComponent,
    WorkspaceRootAttachmentComponent,
    WorkspaceTableAttachmentsComponent,
    WorkspaceProjectAttachmentComponent,
    TestSummaryTableComponent,
    BlueprintFieldCheckboxComponent,
    BlueprintFieldDateComponent,
    BlueprintFieldDatetimeComponent,
    BlueprintFieldDropdownSingleComponent,
    BlueprintFieldDropdownMultipleComponent,
    BlueprintFieldMemoComponent,
    BlueprintFieldNumberComponent,
    BlueprintFieldRadioGroupComponent,
    BlueprintFieldTableComponent,
    BlueprintFieldUserComponent,
    BlueprintFieldUrlComponent,
    BlueprintFieldFormattedTextComponent,
    BlueprintFieldTextComponent,
    BlueprintEdgePropertyComponent,
    BlueprintRootPropertyComponent,
    BlueprintNodePropertyComponent,

    NodeFieldsTableComponent,
    NodeFieldAddDialogComponent,
    NodeFieldEditDialogComponent,
    NodeFieldDeleteDialogComponent,
    CommentComponent,
    OrgAttachmentsComponent,
  ],
  imports: [
    TableComponent,
    CatchCoreModule,
    ColorPickerModule,
    SharedEditPanelRoutingModule,
    FilterStatusColorPipe,
    TestStepTableModule,
    NodeSummaryTableModule,
    EditorModule,
    ButtonModule,
    PopoverModule,
    InputTextModule,
    TextareaModule,
    SelectModule,
    AutoCompleteModule,
    TooltipModule,
    DatePickerModule,
    CheckboxModule,
    InputNumberModule,
    InputMaskModule,
    MultiSelectModule,
    IconFieldModule,
    InputIconModule,
    RippleModule,
    FormsModule,
    TabsModule,
    RichTextFieldComponent,
    ImageLightboxComponent,
    StripHtmlPipe,
  ],
  exports: [OrgAttachmentsComponent, EditPanelContainerComponent],
  providers: [
    EditPanelContainerComponent,
    ColorPickerModule,
    DataService,
    NodeFieldsDataService,
    {
      provide: MatDialogRef,
      useValue: {},
    },
  ],
})
export class SharedEditPanelModule {}
